export default __webpack_public_path__ + "static/media/loan.521d7cd3.png";